var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      attrs: {
        placement: "top-start",
        trigger: "method",
        customClass: "attachment-richtext__menu",
        disabled: _vm.disabled,
        isOpen: _vm.showAttachmentMenu
      },
      on: {
        open: function($event) {
          _vm.showAttachmentMenu = true
        },
        close: function($event) {
          _vm.showAttachmentMenu = false
        }
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _c("CompassMenuItem", {
                attrs: {
                  label: _vm.$t.__(
                    "richtext.customoptions.AttachmentRichText.add_attachment_from_sellsy"
                  ),
                  prefixIcon: "folder"
                },
                on: { click: _vm.displaySelectFileDropdown }
              }),
              _vm._v(" "),
              _c("CompassMenuItem", {
                attrs: {
                  label: _vm.$t.__(
                    "richtext.customoptions.AttachmentRichText.add_attachment_from_device"
                  ),
                  prefixIcon: "download"
                },
                on: { click: _vm.selectFilesFromComputer }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.getExtensionOptionLabel(),
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled,
            placement: "top"
          }
        },
        [
          _c("CompassIconButton", {
            ref: "attachmentRichTextTrigger",
            attrs: {
              icon: _vm.getExtensionOptionIcon(),
              disabled: _vm.disabled && _vm.loadingAttachment,
              active: _vm.activeStyle(_vm.option),
              showDropdown: "",
              size: "small"
            },
            on: {
              click: function($event) {
                _vm.showAttachmentMenu = !_vm.showAttachmentMenu
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file", multiple: "" },
        on: { change: _vm.handleFileChange }
      }),
      _vm._v(" "),
      _c(
        "CompassDropdown",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleClickOutside,
              expression: "handleClickOutside"
            }
          ],
          attrs: {
            parentRef: "attachmentRichTextTrigger",
            dropdownClass: "attachment-richtext__dropdown",
            placement: "top-start",
            isVisible: _vm.showSelectFilesDropdown,
            actions: _vm.selectFilesDropdownActions,
            filterablePlaceholder: _vm.$t.__("common.actions.search"),
            filterable: "",
            isAutoComplete: "",
            noResults: _vm.files.length === 0,
            noResultsLabel: _vm.selectFilesDropdownNoResultsLabel,
            loading: _vm.isLoadingFiles
          },
          on: { filter: _vm.searchFilesFromSellsy }
        },
        _vm._l(_vm.files, function(file) {
          return _c(
            "CompassDropdownOption",
            {
              key: file.id,
              attrs: {
                value: file.id,
                label: _vm.getFileName(file),
                caption: _vm.getFileSize(file.size)
              },
              on: {
                click: function($event) {
                  return _vm.selectFileFromSellsy(file)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "attachment-richtext__dropdown-option" },
                [
                  _c("svg", {
                    staticClass: "attachment-richtext__dropdown-option-icon",
                    attrs: { viewBox: _vm.getFileIconViewBox(file.extension) },
                    domProps: {
                      innerHTML: _vm._s(_vm.getFileIcon(file.extension))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "attachment-richtext__dropdown-option-label typographies-paragraph-medium-regular"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getFileName(file)) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }